import UiElement from '../../../shared/ui-element/ui-element';

import './search.scss';

class Search extends UiElement {
  constructor({...props}) {
    super();
    this.activeSearchHandler = props.activeSearchHandler;
    this.defaultSearchHandler = props.defaultSearchHandler;
  }

  ui = {
    searchContainer: '.js-stretch-search',
    searchToggle: '.js-stretch-search-toggle',
    searchInput: '.js-search-input',
    body: 'body',
  };

  events = {
    'click @ui.searchToggle': 'handleSearchToggle',
    'click @ui.body': 'handleSearchClose',
  };

  static activeSearchingClass = 'stretch-search_active';

  handleSearchToggle() {
    const isActiveSearch = this.ui.searchContainer.classList.toggle(Search.activeSearchingClass);
    if (isActiveSearch) {
      this.ui.searchInput.focus();
      this.activeSearchHandler();
    } else {
      this.ui.searchInput.value = '';
      this.defaultSearchHandler();
    }
  }

  handleSearchClose(e) {
    const isActiveSearch = document.getElementsByClassName(Search.activeSearchingClass).length;
    const isInput = e.target === this.ui.searchInput;
    const isToggle = e.target === this.ui.searchToggle;

    if (isActiveSearch && !isInput && !isToggle) {
      this.ui.searchContainer.classList.remove(Search.activeSearchingClass);
      this.ui.searchInput.value = '';
      this.defaultSearchHandler();
    }
  }
}

export default Search;
